module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("CHAPTER 3")])]), _c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_c('p', {
    staticClass: "orna"
  }, [_c('img', {
    attrs: {
      "alt": "The Crusader States",
      "src": "images/ornament.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_vm._v("The First Settlers")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "p50"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("F")]), _vm._v(" one of the objections to Raymond of Toulouse as ruler of Jerusalem was his age, then it is ironic that he outlived Godfrey of Bouillon, who died only a year after his election, on 18 July 1100. Returning from a campaign in the lands of Duqaq of Damascus, Godfrey had begun to make his way south along the coast, where he was met by the emir of Caesarea, who offered him dinner. The duke, however, says Albert of Aachen, ‘refused food with every polite expression of thanks, tasting only some oranges’. Soon after, he began to feel ill, and was secretly taken to a guesthouse at Jaffa, where four of his companions supported his head and feet. But news soon spread and both Vitale Michiel, doge of Venice, who had just arrived with his fleet at Jaffa, and Tancred hurried to visit him. Godfrey was aware that his condition was deteriorating, and had himself moved to Jerusalem, closely followed by the Venetians. In Jerusalem the Venetians visited the Holy Sepulchre and the other holy sites, having been reassured by the duke that he was improving, before returning to Jaffa. Two weeks later, a combined force led by Tancred and Daibert of Pisa, who had replaced Arnulf of Chocques as patriarch of Jerusalem the previous Christmas, set out to besiege Acre, although they were obliged to leave behind Godfrey's deputy, Warner, count of Grez, who had himself become so ill that he had had to be carried to Jerusalem on a stretcher. Four days later, Godfrey's illness became critical. ‘He made confession of his sins in true remorse of heart and with tears, took communion of the Lord's body and blood and, thus secured and protected by a spiritual shield, he was taken from this light.’ He was buried at the entrance to the Holy Sepulchre. His illness had lasted five weeks. Six days later, on 22 July, Warner of Grez also died, and was buried in the entrance to the church of the Tomb of the Virgin in the valley of Jehoshaphat."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-1",
      "id": "nr3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The causes of Godfrey's lingering death are not known. William of Tyre speaks of ‘a violent and incurable disease’, perhaps basing himself on Ekkehard "), _c('a', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("of Aura, who says that, during the summer, many (including Godfrey) died of a "), _c('i', [_vm._v("pestilentia")]), _vm._v(", that is, an infectious or contagious disease. As Ekkehard visited the kingdom personally the following year, he was probably well informed."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-2",
      "id": "nr3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" At the same time, the physical stress of the crusade, together with the severe injuries he had received when attacked by a bear in August 1097, must have made him vulnerable."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-3",
      "id": "nr3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Although by no means the most distinguished or influential of the leaders during the expedition itself, he was uniquely associated with the achievements of the First Crusade in the minds of contemporaries, and remained an inspirational figure for later generations. Within twenty years of his death, Albert of Aachen was able to present his career as foreseen in a dream by a knight called Hercelo of Kinzveiler. In the vision, Hercelo had seen Godfrey on Mount Sinai, receiving the blessing of two men in white. As interpreted by Albert, this meant that ‘in the spirit and gentleness of Moses there may arise a spiritual leader of Israel, preordained by God and prince of the people’. This leader was Godfrey, who succeeded where all others had failed and was ‘made ruler of the city and commander of the people’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-4",
      "id": "nr3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The reality was more mundane. The victory over the Egyptians near Ascalon on 12 August 1099 had temporarily removed the threat that the Fatimids would immediately retake Jerusalem, a very real danger since, only the year before, in July 1098, they had driven out the Artukid emirs, Soqman and Il-Ghazi. The Franks were aware of this and sought to follow up with an assault on Ascalon itself. Apparently, a few days after the battle, the citizens secretly offered to hand over the city to Raymond of Toulouse, as the only Christian leader they could trust. However, Godfrey and Raymond, already rivals after Godfrey's election and the dispute over the possession of the Tower of David, quarrelled over the command of the army, and therefore failed to present a credible threat."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-5",
      "id": "nr3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" In Albert of Aachen's version, this was the result of Raymond's envy of Godfrey's ‘glory’, a state of mind that led him to advise the citizens to hold out as the bulk of the army was about to return home."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-6",
      "id": "nr3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Albert clearly reflects the Lotharingian viewpoint, but Ralph of Caen, too, blames Raymond's ‘arrogant and vain acts’ for this failure, a judgement influenced by what he discerned as the great damage the city had subsequently caused to the Christians, while William of Malmesbury, writing about twenty years later, presents Raymond as filled with resentment and says that, as a consequence, he ‘handed over the keys of the city to the enemies of God’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-7",
      "id": "nr3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Although Godfrey did attack Ascalon, he was abandoned by Raymond and, left with an inadequate force of 700 mounted men, decided that the siege was no longer tenable."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-8",
      "id": "nr3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The Franks could not afford such internecine conflict. William of Tyre, perhaps anxious to emphasise the importance of divine protection, may have "), _c('a', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("exaggerated the insecurities of the time, but it is nevertheless clear that the crusaders’ grip on the few enclaves they held in Palestine was too shaky to ensure safe travel or to support a settled agriculture. Indeed, the situation was exacerbated by a strike of Muslim peasants ‘in order that our people might suffer from hunger’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-9",
      "id": "nr3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" Fulcher of Chartres, the only chronicler to have visited Jerusalem at this time, when he took part in the pilgrimage of Bohemond and Baldwin at Christmas 1099, describes the privations of the journey from Edessa, including hunger, cold and heavy rain. Nobody would sell them supplies and many stragglers were picked off despite the size of the army. When they reached Jerusalem, the rotting bodies of its defenders still lay in the streets and outside the walls, creating a miasma that intruded upon the joy of worshipping at the holy places."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-10",
      "id": "nr3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Godfrey's failed attack on Arsuf in the autumn of 1099 did nothing to alleviate the situation. Although this was a serious assault lasting two months, from 15 October to 15 December, it was undermined by lack of sea power and the destruction of two of his siege engines, finally ending when the weather became too bad."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-11",
      "id": "nr3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" As a result, in the winter of 1099–1100 he was left with no option but to conduct "), _c('i', [_vm._v("chevauchées")]), _vm._v(" and foraging expeditions in order to survive. One of these, in February 1100, on the hinterland of Arsuf, took advantage of the need for local Muslims to begin preparations for the new agricultural year by attacking the populace while they were in the fields, and was sufficiently ferocious to persuade the emirs of Ascalon, Caesarea and Acre to pay tribute in money and kind, as well as gaining the release of Gerard of Avesnes, a knight from Hainault who had been held as hostage and was thought to have been killed."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-12",
      "id": "nr3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Combined operations with Tancred in May 1100 against the emir of Sawad, whose lands lay immediately to the east of the Jordan, had a similar effect. He was, says Albert of Aachen with some relish, called the Fat Peasant, ‘on account of his very great and gross corpulence and his worthless character, in which he seemed to be entirely a peasant’. The Franks spent a week in his lands ‘inflicting fire and slaughter’ before returning to Jerusalem with ‘immeasurable booty’. Tancred now set his sights on Damascus, sending six men to demand the surrender of the city and Duqaq's submission to the Christian faith. It was a risky mission and the ruler's response was to decapitate five of the envoys, sparing only the one who agreed to accept ‘the Turkish religion’. Tancred retaliated by devastating his lands for two weeks before a settlement was made."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-13",
      "id": "nr3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Brutal and sometimes desperate fighting was an integral part of these encounters. Albert of Aachen recorded how, during the siege of Arsuf, Gerard of Avesnes had been tied to a mast in the form of a crucifix, with the result "), _c('a', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("that, during Godfrey's assault, he had been pierced by ten arrows, while over fifty men manning one of the siege engines were killed when it was set on fire by the defenders. ‘Some had broken backs and necks, others legs half cut off, hips or arms, certain had burst intestines from the unbearable weight of the timbers; having no strength to free themselves, they were reduced to ember and ash along with the timbers.’ Albert's account of Godfrey of Bouillon's men setting upon the peasants and townsmen while they were cultivating their vineyards and fields outside the walls is equally gruesome: ‘they attacked with a sudden cavalry charge some thousand Saracens who came out of the city, and, destroying them with savage wounds, they left over five hundred half-dead on the battlefield, their noses cut off, or hands and feet, while the victors returned to Jerusalem with citizens’ wives and sons as prisoners.’ Albert's description of this as a battle can hardly be justified, but it does encapsulate the balance of weakness in southern Palestine at this time."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-14",
      "id": "nr3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the end, slash-and-burn could not achieve long-term results; only the capture of the sea ports in combination with the establishment of fortified strong points in the hands of capable lords could offer the Franks a measure of security. Although he had failed at Ascalon and Arsuf, Godfrey rebuilt the walls of Jaffa and improved the port facilities, an action, Albert of Aachen says, that led to the subjugation of the other Muslim cities and to a great increase of Christians arriving by sea. He strengthened Tiberias with ‘a rampart and invincible defences on the steep slope of the mountain’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-15",
      "id": "nr3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Moreover, the exodus that followed the ending of the expedition was not as dramatic as has sometimes been suggested. Although some of the major leaders returned home, many of those who remained or arrived soon after derived from important families in the West, so that, from the beginning, despite (or perhaps because of) the evident fragility of some dynastic lines and the heavy losses in the unavoidable battles, there developed a degree of aristocratic cohesion which strengthened in the course of the twelfth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-16",
      "id": "nr3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Equally importantly, Godfrey had also retained a small group around him which Albert of Aachen describes as the "), _c('i', [_vm._v("domus Godefridi")]), _vm._v(", an immediate circle of men who had decided to stay in Palestine, which included at least twenty-one seculars, about half of whom were Lotharingian, and three clerics."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-17",
      "id": "nr3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("At the same time Godfrey began a process of enfeoffment: Tancred was granted Tiberias and Gerard of Avesnes compensated for his near-martyrdom with fiefs worth 100 marks and possession of the castle of Hebron (St Abraham). This ‘castle’ was, in fact, a large enclosure dating from Herodian times, now known as the Haram al-Khalil."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-18",
      "id": "nr3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Robert of Apulia, who had taken part in the massacre of the populace around Arsuf, was given the tribute from the town in return for a cash payment."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-19",
      "id": "nr3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" While he lay sick in Jerusalem in "), _c('a', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("early July 1100, Godfrey made an anticipatory grant of Haifa to a crusader from Dargoire in the Upper Loire region, Geldemar Carpenel, ‘if they managed to capture it’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-20",
      "id": "nr3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" He evidently made several smaller grants as well, for, only days after his arrival to claim the kingship following Godfrey's death, Baldwin assembled all the holders of equipment, money and "), _c('i', [_vm._v("beneficia")]), _vm._v(", that is, fiefs, so that they could account for their holdings and then swear fealty to him, ‘returning the fiefs individually to each person’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-21",
      "id": "nr3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" In addition, Godfrey issued an edict declaring that each year a written record ("), _c('i', [_vm._v("prescriptio")]), _vm._v(") should be made of those who had stayed in their tenure for a year and a day, a measure aimed at preventing those who had left from returning to claim property after a year."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-22",
      "id": "nr3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("He began, too, the endowment of religious institutions, granting the canons of the Holy Sepulchre twenty-one villages in a key area to the north of Jerusalem."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-23",
      "id": "nr3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" These were settled by westerners who, initially at least, must have been survivors of the crusade. Whatever their previous status, these were now freemen, occupying allocated plots of land and paying tithes and a proportion of their harvests. Many must have established themselves as family units, marrying local Christians, widows of dead crusaders or former prostitutes who had come on the crusade as penitents. The presence of western women in the crusading host is well attested, in particular in the denunciations of clerics intent on explaining military failures in terms of immorality, although self-preservation rather than sexual laxity must have been the main determinant of female behaviour given the circumstances they were obliged to face during the expedition."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-24",
      "id": "nr3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The rapid establishment of such communities was essential since Jerusalem was dependent upon its rural hinterland to supply its markets with fresh fruit, vegetables and meat, as well as processed food and drink. The canons particularly needed regular production of oil and wine."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-25",
      "id": "nr3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" As well as their obvious economic value, these villages had a strategic role, for they were developed along the main routes to the north towards Nablus, and the west towards Lydda, Ramla and Jaffa."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-26",
      "id": "nr3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" In 1124, Fulcher of Chartres mentions a tower at al-Bira, one of the larger villages, constructed, he says, ‘in our time’, strong enough to provide refuge during a raid from Ascalon."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-27",
      "id": "nr3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Given the insecurity of the rural areas and the roads at the beginning of the century, it is likely that some fortification of settlements had been erected almost immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Godfrey himself held a corridor of land from Jaffa to Jerusalem, encompassing Lydda and Ramla, and extending a short distance south to Bethlehem. Such a limited territory could only sustain a relatively small force. According to Albert of Aachen, the raids into the lands of the emir of Sawad had been conducted by 200 knights and 1,000 infantry under Godfrey, to which "), _c('a', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("Tancred had contributed a further 100 knights."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-28",
      "id": "nr3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" Ralph of Caen, who presumably obtained his information from Arnulf of Chocques and Tancred, says that, after the departure of the leaders in late August, ‘barely 200 men, who were equipped with breastplates, remained to defend Jerusalem’, about eighty of whom belonged to Tancred's household."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-29",
      "id": "nr3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" To put this in perspective, at the battle of Ascalon on 12 August, the Franks had mustered 5,000 knights and 15,000 foot soldiers, an army that, the crusaders claimed, had even then been outnumbered by twenty to one."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-30",
      "id": "nr3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" His one port was Jaffa, which was in such poor condition that its inhabitants had abandoned it as indefensible shortly before the crusaders arrived,"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-31",
      "id": "nr3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" while the road from there up to Jerusalem was described by the English pilgrim Saewulf, in the summer of 1102, as very hard and dangerous because of Saracen ambushes and the lack of water."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-32",
      "id": "nr3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" In contrast, as Daibert, archbishop of Pisa, Godfrey and Raymond of Toulouse explained to the pope in a letter of September 1099, any one of the many coastal cities in Muslim hands had more men than the entire crusading army."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-33",
      "id": "nr3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Godfrey was evidently worried that if the situation became widely known in the West it would deter new crusaders. Guibert of Nogent, writing a decade later, recalled that he had been told by Baldwin of Bourcq, a kinsman of Godfrey, who had travelled with him on the First Crusade, that he was with Godfrey when they had fought off an ambush of 120 Turks with only twenty knights, ‘made the more audacious by the aid we had continually experienced from God’. On this occasion, in order to inspire those who had remained in France, Godfrey had asserted that he had a vast fortune, derived from ten castles and an abbey, which paid him a sum of 1,500 marks annually. ‘And if God favours my taking Aleppo, I shall soon have 100 castles under my command. Do not believe those who have retreated, claiming that we grow weary with hunger, but rather trust in my words.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-34",
      "id": "nr3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, at this time ports were more important than Aleppo and they could not be taken without the help of the Italian fleets. Most were held by emirs, largely independent of higher authority since the tenth century, when the bureaucratic government of the Abbasids at Baghdad had begun to fall apart. As a result, none of these rulers possessed forces comparable in size to Mesopotamian atabegs like Kerbogha, nor could they assemble viable coalitions, but even so their "), _c('i', [_vm._v("’askar")]), _vm._v(", or mounted guards, reinforced by local troops and mercenaries, often seemed to be sufficient to see off the Frankish threat."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-35",
      "id": "nr3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Moreover, at various times they received help from Egyptian ships, which had by no means conceded the sea to the Christians."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-36",
      "id": "nr3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" The arrival of a large Pisan fleet at Jaffa in late December 1099 therefore offered Godfrey an unprecedented opportunity. The Pisans were led by their archbishop, Daibert, who "), _c('a', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("had landed at Latakia two months before with what they claimed were 120 ships, a fleet too large to be challenged by the Egyptians at Ascalon, where poor harbour facilities precluded the retention of shipping on this scale."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-37",
      "id": "nr3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" The archbishop himself reached Jerusalem on 21 December, accompanied by Bohemond and Baldwin, now established in Antioch and Edessa respectively."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-38",
      "id": "nr3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Daibert's exact status remains unclear, although it is generally held that he possessed legatine powers received from Urban II. He had certainly been strongly associated with the late pope, as he had taken the Cross at Clermont and, in 1098, had acted as his legate in Castile. His record in Pisa suggests a strong commitment to the papal reform programme, so it is reasonable to see him as an emissary of Urban II and therefore carrying all the prestige and weight that this implied, even though any legatine powers he may have possessed would have lapsed with the pope's death."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-39",
      "id": "nr3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Urban II had originally intended the Pisan ships to be used to help the crusaders at Antioch, but in these new circumstances they provided an ambitious prelate like Daibert with the leverage he needed to establish his own position within a state in which the institutional structure had by no means been properly formed. He proceeded to translate this into his own election as patriarch, when he was crowned on Christmas Day."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-40",
      "id": "nr3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" It was not difficult to find reasons for the removal of Arnulf of Chocques, whose clash with Tancred even Ralph of Caen had been unable to present as a high-minded issue of principle, although in this case Ralph describes Arnulf as acceding with grace, because ‘he hoped that the other would be more successful in spreading Christianity than he might be’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-41",
      "id": "nr3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Indeed, there is good reason to think that Daibert did not believe that Arnulf was patriarch in the first place, since his election had not been confirmed, which may explain why Fulcher of Chartres, Albert of Aachen and William of Tyre all present Daibert as the first Latin patriarch. In 1102, with Daibert out of office, Arnulf reappears as archdeacon of Jerusalem, a not insignificant role despite his demotion."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-42",
      "id": "nr3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("According to William of Tyre's later account, Daibert now established his authority over the secular leaders when ‘both Duke Godfrey and Prince Bohemond humbly received from his hand, the former the investiture of the kingdom, and the latter that of the principality, thus showing honour to him whose viceregent on earth they believed the patriarch to be’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-43",
      "id": "nr3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" This was evidently the work of Bohemond, whose Christmas pilgrimage to Jerusalem cannot have been a coincidence, whatever the degree of personal piety involved, since it gave him sanction for his seizure of Antioch, made in clear contravention of his oath to Alexius."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-44",
      "id": "nr3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Daibert had originally landed at Latakia, still in Greek hands, and was in the process of helping Bohemond attack the city when they had both been stopped by Raymond of Toulouse, "), _c('a', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("Robert of Normandy and Robert of Flanders returning north after the battle of Ascalon."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-45",
      "id": "nr3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Daibert's common front with Bohemond must have been formed at this time, leading to the archbishop's Christmas election and Bohemond's investiture. Daibert followed this up by appointing three Latin archbishops and one bishop within the patriarchate of Antioch, ignoring the authority of the Greek patriarch, John IV. This had evidently been planned in advance, as Ralph of Caen says that the four, ‘namely Roger of Tarsus, Bartholomew of Mamistra, Bernard of Artah and Benedict of Edessa, had come with Bohemond and Baldwin after being elevated to the priestly office’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-46",
      "id": "nr3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" As subsequent events demonstrate, Godfrey was a good deal less enthusiastic, since he had no need of such confirmation, but without Daibert's co-operation he would not have had access to the Pisan fleet and his recent failure to take Arsuf, directly attributable to his naval weakness, must have been fresh in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Neither Bohemond nor Baldwin could afford to linger long in the south. On the eve of Epiphany (5 January), they met Godfrey and Daibert at the Jordan, ‘in which,’ says Albert of Aachen, ‘they bathed and enjoyed themselves’. After this, ‘Baldwin and Bohemond rejoiced with the duke in all happiness and in shared friendship, and there in the region of Jordan they kissed with tears and took their leave of each other’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-47",
      "id": "nr3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Daibert was now in a dominant position. At the time of his election he had received the ‘patriarch's quarter’ in Jerusalem, together with new revenues, but he was evidently not satisfied. In William of Tyre's words: ‘The patriarch demanded that the duke give over to him the Holy City of God with its citadel and likewise the city of Jaffa with its appurtenances.’ Although presented in an emollient form by William, this clearly provoked a furious dispute, but by stages Godfrey made the required concessions, granting the fourth part of Jaffa on 2 February 1100, followed by the city of Jerusalem and its citadel on Easter Day (1 April). Jerusalem, however, would not actually be handed over until Godfrey had gained control of what William describes vaguely as ‘one or two other cities’, but which Daibert himself calls ‘Babylon and other cities’. If he died without a legitimate heir, all these possessions would pass under the control of the patriarch."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-48",
      "id": "nr3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When these events took place, neither Fulcher of Chartres nor Albert of Aachen was present, while William of Tyre was writing more than seventy years later. Even so, this was no passing reference by William, who had researched the subject with some intensity, perhaps at least partly because he had ambitions to be patriarch himself. He could find no evidence that Godfrey had been appointed by the leaders of the crusade on these conditions, but instead traces the origin of ‘the patriarch's quarter’ to the period of Egyptian rule under Caliph al-Mustansir in 1063. The Christian inhabitants had been "), _c('a', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("assigned a fourth part of Jerusalem to rebuild but lacked the resources to do so. They therefore appealed to the Byzantine emperor, Constantine X (1059–67), for help, which he granted on condition that the quarter concerned be assigned exclusively to the Christians, a condition to which the caliph agreed. ‘From that day, then, and in the manner just described, this quarter of the city had had no other judge or lord than the patriarch, and the church therefore laid claim to that section as its own in perpetuity.’"), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-49",
      "id": "nr3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, although William goes on to describe the exact extent of the patriarch's quarter – which he was able to do from direct personal experience – he offers no explanation for the additional, very sweeping concessions in Jerusalem and Jaffa. William clearly derived his information from a letter written by Daibert himself to Bohemond after the death of Godfrey on 18 July. Probably William has not reproduced the text verbatim, but he was at least recording the main elements of a letter that had really existed, for reference is made to it by Albert of Aachen."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-50",
      "id": "nr3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Since it must be assumed that, ultimately, Godfrey's main concern was not ‘fear of the rebuke of the Lord’, as William asserts, but the deployment of the Pisan fleet against the Muslim ports, then the most convincing explanation is that the concession of the quarter in Jaffa was aimed at satisfying the Pisans in a manner that was to become familiar in future agreements with the Italian maritime cities."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-51",
      "id": "nr3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Moreover, the city of Jerusalem and its citadel, the latter the subject of such bitter dispute with Raymond of Toulouse, would not be handed over until Godfrey had captured other cities, a condition that surely obliged the Pisans to act if they wanted the terms of the agreement carried out. William, however, is not helpful in identifying these cities. His version of Daibert's letter refers to Babylon, which, if it means Cairo, is so unlikely as to negate the concession entirely, given that Godfrey had not even been able to take Arsuf."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-52",
      "id": "nr3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Much closer to the time than William is a compilation of an anonymous scholar known as the "), _c('i', [_vm._v("Work on Geography")]), _vm._v(", which can be dated to between the years 1128 and 1137. Godfrey, it says, vowed ‘that if the Divine Piety allowed him to capture Ascalon, he would give the whole revenue of Jerusalem into the hands of the Soldiers of God in the Holy Sepulchre and to the authority of the Patriarch’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-53",
      "id": "nr3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In this light the settlement between Godfrey and Daibert looks much less one-sided than it first appears. Daibert's acquisition of Jerusalem would have had to be balanced by the acquisition of other, more strategically important cities, which, if on the coast, would have been more lucrative as well. Nor does the agreement demand that Godfrey marry and produce male heirs, which was an unlikely circumstance, but only that he should be succeeded by a legitimate male heir, which would have meant either of his brothers, Eustace "), _c('a', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("or Baldwin."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-54",
      "id": "nr3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Presumably Baldwin was well aware of this when he helped make Daibert patriarch at Christmas 1099.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In fact, nobody knows what instructions Urban II gave Daibert but, in any case, like the crusaders, to some extent he was obliged to react to the situation as he found it."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-55",
      "id": "nr3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" On the face of it, he was apparently exploiting the shortages of men and money to further his own personal ambition. Yet such a view distorts contemporary perceptions, for he had been sent by a reforming pope, whose central tenets were that fornicating priests be removed and that secular appointment to ecclesiastical office was a sin punishable by excommunication. Daibert would have been very conscious of the importance of the unresolved conflict over investitures. Moreover, the apparent attempt to build a patriarchal patrimony was little different from the papacy's own efforts to create a territorial base in central Italy, a policy vigorously pursued from the mid-eleventh century and continued into the thirteenth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-56",
      "id": "nr3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" Indeed, it was not in his interest to weaken the new state and, after Easter 1100, he sent an appeal to the clergy and people of the Teutonic regions, to whom ‘God has given riches beyond all other peoples’. Jerusalem, he said, was under attack from all sides, but after its capture many had returned home. Others followed after celebrating Easter on 1 April, taking advantage of the presence of Pisan and English ships. It was costly to keep those who remained, and without German help they could not continue to pay the promised wages."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-57",
      "id": "nr3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Whatever may have been Urban's specific instructions, he surely must have told Daibert to strengthen the Latin Church in the East as far as he was able.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, if reform ideas lay behind his actions in dealing with others, there is little to indicate that Daibert thought they applied to himself. His election to the patriarchate was blatantly the result of secular influence. Fulcher of Chartres, who was there at the time, says that the pilgrimage of the leaders to the Jordan was ‘after the Duke and the other chief men had chosen the above-mentioned Lord Daimbert to be Patriarch in the Church of the Holy Sepulcher’, while Daibert himself, as quoted by William of Tyre, reminded Bohemond that he had brought about his election, and that Baldwin had supported him ‘in choosing me as a patriarch and rector of the church at Jerusalem’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-58",
      "id": "nr3-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Put in place by three seculars, two of whom had been hostile to church reform, accepting an office that made him ‘a pluralist on a grand scale’,"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-59",
      "id": "nr3-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" and completely disregarding Greek rights and claims in both Latakia and Antioch hardly made Daibert a shining example of the new prelacy that the reformers had sought to create. In the end it is difficult to see these events as an attempt to found a theocratic state or indeed as an example of the application of Gregorian principles; instead, they look much more like a power struggle between Godfrey and Daibert in which each attempted to "), _c('a', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("exploit whatever advantages came to hand. Such factional conflicts became common-place in the crusader states during the twelfth century. Not surprisingly, therefore, Albert of Aachen presents Daibert as ingratiating, treacherous and venal, while William of Tyre saw him as a ‘man of God’, who was the Lord's earthly representative."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-60",
      "id": "nr3-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" Ironically, all this political manoeuvring eventually proved fruitless, as the Pisan fleet does not seem to have been used in any systematic attack on the coastal emirates, although the sailors did help in the rebuilding of Jaffa in the middle of January. Then, immediately after Easter, in early April, the Pisans sailed for home, soon to be replaced by an even larger fleet of 200 Venetian ships under the doge, Vitale Michiel, and Enrico Contarini, bishop of Castello (Venice), which, having overwintered at Rhodes, arrived on about 10 June.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Warner of Grez and Tancred now negotiated a treaty with the Venetians, the terms of which set the pattern of future agreements with the maritime cities and, in that sense, began the process of establishing the Italian communes in the East, whose inhabitants became a characteristic element in the social structure of the Frankish littoral in the course of the twelfth century. In any cities which the Franks captured then or in the future, whether on the coast or inland, the Venetians should have a church and a square suitable for a market. Booty would be divided one-third to the Venetians and two-thirds to the Franks, except in the case of Tripoli, when the division should be in equal parts. The city of Tripoli itself, if captured, would be granted to the Venetians in its entirety, except for an annual payment to Jerusalem as a mark of reverence to the holy places. The Venetians evidently regarded the allowance of two-thirds of the booty to the Franks elsewhere as a concession ‘because they [the Franks] were not wealthy’. Beyond this, they were to have security against claims of right of wreck for all their merchandise. Godfrey, though still incapacitated, was nevertheless able to confirm these terms."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-61",
      "id": "nr3-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("As the departure of the Pisans shows, the use of fleets was constrained by sailing conditions, so the agreement covered the period between 24 June and 15 August, evidently based on the hope that success could be achieved during a summer campaign before the arrival of the autumn made it imperative to leave."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-62",
      "id": "nr3-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Around 2 July, they chose Acre as the target and, two weeks later, the army left Jaffa. At some point, however, they decided to besiege Haifa first, perhaps influenced by news of the deaths of Godfrey and Warner of Grez, which effectively gave Tancred and Daibert a free hand."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-63",
      "id": "nr3-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" Albert of Aachen says that initially Tancred was unenthusiastic ‘on account of envy’, but was encouraged by Daibert, who effectively promised him possession of the city if he could take it. In the face of what now became a ferocious attack, the city, isolated by the Venetian blockade, fell on around 20 August, and the Franks "), _c('a', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("massacred the population and seized large quantities of plunder. Tancred, supported by Daibert, then forced out Geldemar Carpenel, to whom Godfrey had granted the city if it should be taken, thus adding a vital component to the territories he already held by gaining an outlet to the sea."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-64",
      "id": "nr3-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("On the face of it, the fall of Haifa presaged the triumph of the faction led by Daibert and Tancred, but in the twelfth century thrones could be won by speed of thought and action, as well as by the chance of proximity to the seat of power. Their preoccupation with the siege of Haifa meant that, when Godfrey died, Jerusalem itself was open to seizure by Godfrey's vassals, led by Warner of Grez, and the Lotharingians and other members of Godfrey's "), _c('i', [_vm._v("domus")]), _vm._v(" at once occupied the Tower of David which, as Godfrey, Raymond and Daibert had all demonstrated in the previous months, was the key to control of the city. Although Warner survived Godfrey by less than a week, a delegation led by Robert of Rouen, bishop of Lydda-Ramla, and sent by Geldemar Carpenel and Arnulf of Chocques, at once set out for Edessa, inviting Baldwin to ‘take over the kingdom in your brother's place and sit on his throne’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-65",
      "id": "nr3-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Daibert and Tancred were slower to react. Daibert's appeal to Bohemond, as presented in William of Tyre's version of his letter, was sent after the news had reached them of the seizure of the Tower of David and the departure of the delegation to Baldwin, and therefore was probably not dispatched before the beginning of August. Daibert belatedly realised the danger and his letter to Bohemond is couched in apocalyptic terms. The coming of Baldwin, he said, would ‘bring about the downfall of the church and the destruction of Christianity itself,’ and he asked Bohemond to prevent Baldwin from attempting to take the throne, by force if necessary."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-66",
      "id": "nr3-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Looking back on these events, William of Tyre clearly believed that Daibert had right on his side, calling Warner of Grez the leader of ‘a troublesome faction’ and pointing out that he had died within five days of his seizure of the citadel. ‘This was regarded as a miracle, and it was ascribed to the merits of the patriarch that the enemy and persecutor of the church had met a sudden death.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-67",
      "id": "nr3-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" However, even Daibert's letter says only that Jerusalem and Jaffa should be restored to the Church if Godfrey died ‘without a male heir’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-68",
      "id": "nr3-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" In contrast to William, Albert of Aachen described Daibert's letter as ‘sent in deceit and against the oath which that same patriarch had made with Tancred to the duke, that if he happened to die they would not confer the throne on anyone except his brothers or one of his blood’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-69",
      "id": "nr3-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Moreover, Warner of Grez was the most senior of Godfrey's men, a kinsman who acted as his deputy, who must have known what Godfrey expected. Indeed, when Godfrey had been preparing to depart on crusade, before Baldwin had decided to take part, "), _c('a', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("he had quite explicitly made him his heir in a series of charters that Warner himself had witnessed."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-70",
      "id": "nr3-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In the event, legal arguments proved irrelevant, for circumstances favoured Baldwin. Around 12 August, Morellus, the patriarch's secretary, who was carrying the letter to Bohemond, was intercepted by men of Raymond of Toulouse and the message never reached its destination, while in about mid-August Bohemond himself was captured by the Danishmend Turks during a campaign in the region of Melitene."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-71",
      "id": "nr3-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" After a fruitless attempt to find and rescue Bohemond, Baldwin returned to Edessa at about the same time as the messengers arrived from Jerusalem."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-72",
      "id": "nr3-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" As presented by Fulcher of Chartres, Baldwin himself had no doubts: ‘When it was announced to the Lord Baldwin that all of the people of Jerusalem expected him to succeed as hereditary prince in the kingdom, he grieved somewhat over the death of his brother but rejoiced more over his inheritance.’"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-73",
      "id": "nr3-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" He then conferred Edessa on Baldwin of Bourcq, a kinsman who was the son of Hugh of Rethel in the Ile-de-France, whom he summoned from Antioch, and, on 2 October, set out for Jerusalem with a force of nearly 200 knights and 700 foot soldiers."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-74",
      "id": "nr3-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Such an expedition needed money and, before his departure, Baldwin subjected the population of Edessa to ‘all sorts of extortions’, including seizing ‘a goodly amount of gold and silver’, according to the contemporary Armenian chronicler Matthew of Edessa."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-75",
      "id": "nr3-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The journey took about five weeks, which was about the same length of time as his return to Edessa the previous January after bathing in the Jordan, although on that occasion he had followed a route via the Jordan valley, Tiberias, Banyas and Baalbek."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-76",
      "id": "nr3-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" This time he went first to Antioch, which he reached very quickly, covering the 160 miles in six days. All his actions thereafter suggest that he had complete confidence in his succession. At this point he sent his wife and her household, together with the heavy baggage, to Jaffa by sea, evidently expecting some opposition on the forthcoming march, but apparently not fearing that they would encounter any problems when they arrived in the south."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-77",
      "id": "nr3-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" He stayed four days at Antioch, where, according to Albert of Aachen, he declined an offer of the rulership, before moving to Latakia, where he stopped for another two days."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-78",
      "id": "nr3-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" Here he met Maurice, cardinal-bishop of Porto, who had been appointed legate by Paschal II and had arrived at the port the previous month with a Genoese fleet. This reinforced his already strong position, for he received the backing of both the legate and the Genoese."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-79",
      "id": "nr3-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("However, news of a threatened attack by Duqaq of Damascus provoked a number of desertions and excuses, so he left with a considerably diminished force. This was the critical part of the journey, for, although he received "), _c('a', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("supplies from the emir of Tripoli, on 25 October he was obliged to force a passage along the coast north of Beirut in a serious battle at the Dog River. Fulcher admits, during the sleepless night before, he had been so frightened he would rather have been anywhere other than where he was."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-80",
      "id": "nr3-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" Five days later they passed Haifa, whose citizens sold them bread and wine, but they did not attempt to enter the city because, although Tancred was not there, he was ill-disposed towards Baldwin."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-81",
      "id": "nr3-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" In fact, in late October, Baldwin's supporters had prevented Tancred from entering both Jerusalem and Jaffa, which shows that they had retained the upper hand in the interval since Godfrey's death."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-82",
      "id": "nr3-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" Baldwin himself stopped two days at Jaffa and then, on 9 November, he came within sight of Jerusalem where, Fulcher says, he was greeted with joy by the citizens who, already receiving him as their king, conducted him to the Holy Sepulchre. Daibert was not present, because ‘he was under accusation by certain men around Baldwin’ and he had therefore retired to Mount Sion."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-83",
      "id": "nr3-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Baldwin, as William of Tyre describes him, ‘was a man who loved work and disdained idleness’,"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-84",
      "id": "nr3-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" and, indeed, within six days of his arrival he gave a graphic demonstration of how he intended to rule. Having received oaths of fidelity from his new vassals, he at once set out towards Ascalon, engaging its defenders in a brief but evidently fierce encounter. Then he smoked out and killed some local robbers who had been hiding in caves, apparently near Bait Jibrin, before turning east towards Hebron and the Dead Sea. From there he travelled south into what Fulcher of Chartres calls the mountains of Arabia, as far as Wadi Musa, about 50 miles south of the Dead Sea, before returning to Jerusalem on 21 December."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-85",
      "id": "nr3-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" According to Albert of Aix, he took only 150 knights and fifty foot with him,"), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-86",
      "id": "nr3-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" which suggests a mobile reconnaissance force intended both to demonstrate his presence and to allow him to familiarise himself with the region south of Jerusalem, which he had never before visited. It is a measure of his confidence that, despite the presence of Daibert and Tancred in the immediate vicinity, he was able to leave Jerusalem for over a month, between 15 November and 21 December.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("On 25 December, Baldwin was crowned king in the church of the Nativity in Bethlehem by Daibert. This was an entirely appropriate setting, for it had not been damaged in the conflict and was only 8 miles to the south of Jerusalem."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-87",
      "id": "nr3-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Built over the place of the nativity of Christ which was beneath the main altar, it took the form of a great cross, the interior of which was decorated with Greek mosaics."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-88",
      "id": "nr3-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" Even Fulcher of Chartres, so terse in his account of relations between the secular and ecclesiastical authorities, could hardly pass over such a significant event without comment. ‘This,’ he says, ‘had not been done for his brother and predecessor because Godfrey had not "), _c('a', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("wished it, and there were others who did not approve of it. Still, upon wiser consideration they decided that it should be done.’")])]), _c('a', {
    attrs: {
      "id": "p64"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("As Fulcher presented it, kingship was an honourable calling, approved by God for the fundamental purpose of rendering justice."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/026Notes#en3-89",
      "id": "nr3-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" Anselm of Bec, archbishop of Canterbury, and a personal friend of Countess Ida of Boulogne, Godfrey's mother, seems to have regarded both brothers as kings. In his letter of congratulation to Baldwin, probably written in the spring or summer of 1101, his main concern is that Baldwin should ensure the liberty of the Church, a role that he evidently did not regard as incompatible with a Jerusalem monarchy. Indeed, in a second letter he calls on Baldwin to reign in such a manner as to become an exemplar for all the kings of the earth."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-90",
      "id": "nr3-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" Even so, at this point in his narrative, Fulcher devotes considerably more space to a lengthy description of the Dead Sea, while William of Tyre simply records the coronation without further elaboration, although agreeing with Fulcher that a reconciliation had taken place between Baldwin and Daibert."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-91",
      "id": "nr3-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" In fact, Bethlehem was probably chosen as a location for the ceremony to avoid an overt confrontation over Daibert's claims to Jerusalem, since there was no physical impediment to a coronation in the church of the Holy Sepulchre. For Albert of Aachen, however, Baldwin had similar scruples to Godfrey in not wishing to be crowned in Jerusalem, ‘where Lord Jesus, King of kings and Lord of lords, was brought low and subject even to death for the redemption of the world’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/026Notes#en3-92",
      "id": "nr3-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48adee78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/0123_The_First_Settlers.vue
// module id = 87
// module chunks = 0